module.exports = __webpack_public_path__ + "img/icon_message_normal.64a6013f.png";